import store from '../store';

export default function owner({ next, router }) {
    if(store.getters['roles/roles'][0] !== 'owner') {
        return router.go(-1);
    }

    return next();
}